import get from 'lodash/get';

const ERROR_MESSAGE = 'Something went wrong on our end. Please try again.';

export class ValidationError extends Error {
  constructor(message) {
    super(message);
    this.name = 'ValidationError';
  }
}

export class RequestError extends Error {
  constructor(message) {
    super(message);
    this.name = 'RequestError';
  }
}

export class UnexpectedError extends Error {
  constructor() {
    super(ERROR_MESSAGE);
    this.name = 'UnexpectedError';
  }
}

export async function handleRequestError(operation, selector) {
  const result = await operation.catch(({ response }) => {
    const error = response?.data?.error;
    if (error) throw new RequestError(error);
    throw new UnexpectedError();
  });

  if (result?.data?.error) {
    throw new ValidationError(result.data.error);
  }

  return selector ? get(result, selector) : result;
}
